import React, {useContext} from 'react';
import useStyles from "./styles";
import StepperConnector from "./StepperConnector";
import PaFormSteps from "../../../../shared/PaFormSteps";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import PriorAuthorizationContext from "../../../../contexts/PriorAuthorization/PriorAuthorization.context";
import ResponsiveStepper from "./ResponsiveStepper";
import StepperIcon from "./StepperIcon";
import {Grid} from "@material-ui/core";
import RequiredInfo from "../../../Common/RequiredInfo";
import Typography from "@material-ui/core/Typography";

export default function FormHeader(props) {

    const classes = useStyles();
    const {create: {currentStep, steps}} = useContext(PriorAuthorizationContext);
    const { ...wrapperProps } = props

    if (!steps || !steps[currentStep]) return <></>;

    return (
        <div
            {...wrapperProps}
            id='MEDCAL_RX_STEPPER_HEADER'
            className={classes.headerRoot}>
            <Grid container className={classes.root}>
                <h1 className="pageTitle">{PaFormSteps[currentStep].title}</h1>
                <Grid item xs={2}>
                    <RequiredInfo/>
                </Grid>
                <Grid item xs={7} className={classes.center}>
                    {steps[currentStep].message && <Typography variant="h6">
                        {steps[currentStep].message}
                    </Typography>}
                </Grid>
            </Grid>
            <div>
                <Stepper
                    className={classes.stepper}
                    alternativeLabel
                    activeStep={currentStep}
                    connector={<StepperConnector/>}
                >
                    {PaFormSteps.map((step, i) => {

                        const id = `MEDCAL_RX_STEPPER_ICON_${i}`;

                        return <Step key={step.title}>
                            <StepLabel
                                completed={steps[i].completed}
                                StepIconComponent={() => StepperIcon({step: i, id})}
                                disableTouchRipple
                                disableRipple
                            >
                                {step.title}
                            </StepLabel>
                        </Step>
                    })}
                </Stepper>
                <ResponsiveStepper
                    className={classes.responsiveStepper}
                    steps={PaFormSteps}
                    activeStep={currentStep}
                    completed={steps[currentStep].completed}
                />
            </div>
        </div>
    )
}